import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 440px;
  max-height: 90vh;
  margin: 0 16px;
  border-radius: 8px;
  padding: 8px 16px 16px;
  overflow-y: auto;
  background-color: #fff;
  gap: 12px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-size: 1.1rem;
    color: #333;
  }
`;

const TONS = {
  ok: { fundo: '#e8f5e9', texto: '#1b5e20' },
  erro: { fundo: '#ffebee', texto: '#b71c1c' },
  aguarde: { fundo: '#fff8e1', texto: '#7a5b00' },
};

export const Status = styled.div<{ tone: keyof typeof TONS }>`
  border-radius: 6px;
  padding: 10px 12px;
  font-size: 0.9rem;
  line-height: 1.35;
  word-break: break-word;
  background: ${({ tone }) => TONS[tone].fundo};
  color: ${({ tone }) => TONS[tone].texto};

  strong {
    display: block;
    margin-bottom: 2px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
`;

export const Hint = styled.p`
  font-size: 0.8rem;
  color: #666;
`;

export const Chip = styled.button<{ tone: keyof typeof TONS }>`
  && {
    display: inline-flex;
    align-items: center;
    width: auto;
    height: auto;
    padding: 4px 10px;
    border: none;
    border-radius: 999px;
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
    cursor: pointer;
    background: ${({ tone }) => TONS[tone].fundo};
    color: ${({ tone }) => TONS[tone].texto};
  }
`;
